<div class="container-fluid" style="font-size: 14px;">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title">{{title}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-save button" (click)="add()">Add</div>
  </div>
  
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100 mt-3">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Application Column -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef style="width: 90%" >Applications </th>
      <td mat-cell *matCellDef="let element"> {{element.title}} </td>
    </ng-container>
  
    <!-- Action Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" class="text-center"> Action </th>
      <td mat-cell *matCellDef="let element" class="text-center">
        <div class="d-flex justify-content-center align-items-center">
          <span class="material-icons action edit" (click)="edit(element.id)" [matTooltip]="'Edit'"></span>
          <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
          (click)="deleteApp(element?.id)" style="cursor: pointer; font-size:23px"></i>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <!-- <table class="table col-12 mt-4">
    <tr class="header">
      <th>Applications</th>
      <th>Actions</th>
    </tr>
    <tr *ngFor="let item of listApp">
      <td style="padding-top: 14px; padding-left: 20px;">{{item.title}}</td>
      <td style="text-align: center;" class="d-flex justify-content-center">
        
      </td>
    </tr>
  </table> -->
</div>